import React from "react";
import { FieldProps } from "@rjsf/utils";
import { DocumentUploadInput } from "../../../../../../Submissions/Fields";
import BaseFieldPreview from "./BaseFieldPreview";

const DocumentUploadFieldPreview = (props: FieldProps) => {
  const widgetPreview = <DocumentUploadInput {...props} />;

  return (
    <BaseFieldPreview
      widgetPreview={widgetPreview}
      {...props}
    ></BaseFieldPreview>
  );
};

export default DocumentUploadFieldPreview;
